import React from 'react'
import { Box, Stack, FormControl, TimeChooser, Button, Text } from '@/components/lib'

export default function TimeInput ({ dataType, value, onChange }) {
  return (
    <Box>
      <FormControl
        helperText={value &&
          <Stack spacing={2} direction='row'>
            {dataType.earliestTime && <Text mr={4} color={value < dataType.earliestTime ? 'red' : 'fg.default'}>Earliest allowed: {dataType.earliestTime}</Text>}
            {dataType.latestTime && <Text color={value > dataType.latestTime ? 'red' : 'fg.default'}>Latest allowed: {dataType.latestTime}</Text>}
          </Stack>}
      >
        <Stack direction='row' spacing={2}>
          <Box maxW='300px'>
            <TimeChooser value={value} onChange={(time) => onChange(time || null)} />
          </Box>
          {value && <Button ml={2} onClick={e => onChange(null)}>Clear time</Button>}
        </Stack>
      </FormControl>
    </Box>
  )
}
